import { TaxInvoiceRequest, TaxInvoiceResponse } from 'routes/main/taxInvoice/types';

export const TAX_INVOICE_REQUEST = "TAX_INVOICE_REQUEST";
export const TAX_INVOICE_SUCCESS = "TAX_INVOICE_SUCCESS";
export const TAX_INVOICE_ERROR = "TAX_INVOICE_ERROR";
export const TAX_INVOICE_RESET = "TAX_INVOICE_RESET";

export interface TaxInvoiceRequestAction {
  type: typeof TAX_INVOICE_REQUEST;
  payload: TaxInvoiceRequest;
}

export interface TaxInvoiceSuccessAction {
  type: typeof TAX_INVOICE_SUCCESS;
  payload: TaxInvoiceResponse;
}

export interface TaxInvoiceErrorAction {
  type: typeof TAX_INVOICE_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface TaxInvoiceResetAction {
  type: typeof TAX_INVOICE_RESET;
}

export type TaxInvoiceAction =
  | TaxInvoiceRequestAction
  | TaxInvoiceSuccessAction
  | TaxInvoiceErrorAction
  | TaxInvoiceResetAction;

